import { useAppScopeStore } from '@frontend/scope';
import { useSchedulingLocationInfo } from '../use-scheduling-location-info';

export const useIsRequestTabEnabled = ({ locationIds: locationIdsProp }: { locationIds?: string[] } = {}) => {
  const { getOnlineSchedulingReadyLocationIds } = useSchedulingLocationInfo();
  const { selectedLocationIds } = useAppScopeStore();
  const locationIds = locationIdsProp ?? selectedLocationIds;

  const onlineSchedulingReadyLocationIds = getOnlineSchedulingReadyLocationIds();
  const enabledLocationIds = locationIds.filter((locationId) => onlineSchedulingReadyLocationIds.includes(locationId));
  const isRequestTabEnabled = enabledLocationIds.length > 0;

  return { isRequestTabEnabled, enabledLocationIds };
};
